<template>
  <div class="flex items-center justify-between p-3 border rounded-xl bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700">
    <div class="flex items-center min-w-0 gap-3">
      <div class="flex items-center justify-center w-10 h-10 overflow-hidden bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700">
        <img v-if="isImage" :src="url" class="object-cover w-full h-full" />
        <i v-else class="text-xl mdi mdi-file-document-outline text-slate-400"></i>
      </div>

      <div class="min-w-0">
        <p class="text-xs font-semibold truncate text-slate-700 dark:text-slate-200">{{ label }}</p>
        <p class="text-[11px] text-slate-500 dark:text-slate-400 truncate">
          {{ url || "-" }}
        </p>
      </div>
    </div>

    <a
      v-if="url"
      :href="url"
      target="_blank"
      class="px-3 py-1 text-xs font-semibold rounded-lg bg-primary/10 text-primary hover:bg-primary/20"
    >
      Open
    </a>

    <span
      v-else
      class="px-3 py-1 text-xs rounded-lg bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
    >
      -
    </span>
  </div>
</template>

<script>
export default {
  name: "DocCard",
  props: {
    label: String,
    url: String,
  },
  computed: {
    isImage() {
      return this.url && /\.(png|jpg|jpeg|webp|gif)$/i.test(this.url);
    },
  },
};
</script>
